import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { SignatureService } from '@services/misc/signature.service';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-signature-overlay',
  templateUrl: './signature-overlay.component.html',
  styleUrls: ['./signature-overlay.component.scss'],
})
export class SignatureOverlayComponent implements AfterViewInit {
  @ViewChild('canvas') canvas!: ElementRef<HTMLCanvasElement>;
  signaturePad!: SignaturePad;

  constructor(private signatureService: SignatureService) {}

  ngAfterViewInit() {
    this.signaturePad = new SignaturePad(this.canvas.nativeElement, {
      minWidth: 3,
      maxWidth: 5,
      penColor: 'black',
      backgroundColor: 'rgba(0,0,0,0)', // transparent
    });
    this.resizeCanvas();
  }

  resizeCanvas() {
    const canvasEl = this.canvas.nativeElement;
    canvasEl.width = window.innerWidth * 0.8;
    canvasEl.height = 200;
  }

  clear() {
    this.signaturePad.clear();
  }

  submit() {
    if (this.signaturePad.isEmpty()) {
      alert('Please sign first');
      return;
    }
    const dataUrl = this.signaturePad.toDataURL('image/png');
    this.signatureService.submit(dataUrl);
  }

  cancel() {
    this.signatureService.cancel();
  }
}
